import clsx from 'clsx'
import React from 'react'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text'

import TopicSpeedDropdown from 'app/PelatihanMandiriPage/components/TopicSpeedDropdown'
import { capitalizeFirstLetter } from 'utils/text'
import { useGetKeyPairValue, MILKvKeys } from 'api/microlearning/useAPIKeyValue'
import InfoUpdatedTopic from 'app/PelatihanMandiriPage/components/InfoUpdatedTopic'

import type { TopicSpeedKV } from 'api/microlearning/types'

interface TopicInfoProps {
  pointers: string[]
  shouldShowTab: boolean
  shouldShowInfo?: boolean
  isTopicUpdated?: boolean
}

const TopicInfo = ({
  pointers,
  shouldShowTab,
  shouldShowInfo = true,
  isTopicUpdated,
}: TopicInfoProps) => {
  const { query } = useRouter()
  const { generic_info: genericInfo, topics }: TopicSpeedKV =
    useGetKeyPairValue(MILKvKeys.TopicSpeed).data?.data ?? {}
  const { recommendations } =
    topics?.find((topicSpeed) => topicSpeed.id === query.topik) ?? {}
  const flagShowTab = shouldShowTab

  return (
    <>
      {isTopicUpdated && <InfoUpdatedTopic isForceShow />}
      {shouldShowInfo ? (
        <div className={(clsx(flagShowTab ? 'pt-4' : 'pt-4'), 'px-3 mt-4')}>
          <div
            className={clsx(
              'p-4 bg-white border rounded-t border-subdued',
              !recommendations && 'rounded-b'
            )}
          >
            {pointers && pointers.length > 0 && (
              <ul className="pl-5 list-disc">
                {pointers.map((item, idx) => {
                  return (
                    <Text as="li" variant="body-sm" key={item + idx}>
                      {capitalizeFirstLetter(item)}
                    </Text>
                  )
                })}
              </ul>
            )}
          </div>
          {!!recommendations && (
            <div className="px-3">
              <div className="border border-t-0 rounded-b border-subdued overflow-hidden">
                <TopicSpeedDropdown
                  genericInfo={genericInfo}
                  aksiNyata={recommendations.aksi_nyata}
                  rekomendasiPenyelesaianTopik={
                    recommendations.rekomendasi_penyelesaian_topik
                  }
                  pelajariSemuaModul={recommendations.pelajari_semua_modul}
                />
              </div>
            </div>
          )}
        </div>
      ) : null}
    </>
  )
}

export default TopicInfo
